import ReactGA from "react-ga4";

export const sendReactGAPageView = (pathname, title, setDocTitle=true) => {
    if (setDocTitle) document.title = `iCare | ${title}`;
    ReactGA.send({ hitType: "pageview", page: pathname, title: title });
}

export const displayNumber = (num, dp=2) => {
    return num!==null ? num.toLocaleString('en-US', { minimumFractionDigits: dp, maximumFractionDigits: dp }): ''
}

export const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const isOTPValid = (otp) => {
    return !otp || /^\d{1,4}$/.test(otp)
}

export const isValidPassword = (password) => {
    const hasLowercase = /[a-z]+/;
    const hasUppercase = /[A-Z]+/;
    const hasDigit = /[\d]+/;
    const hasSpecialChar = /[!@#$%&*?]+/;
    const minLen8 = /^[A-Za-z\d!@#$%&*?]{8,}$/;
    const maxLen = 40;
    return {
        hasLowercase: hasLowercase.test(password),
        hasUppercase: hasUppercase.test(password),
        hasDigit: hasDigit.test(password),
        hasSpecialChar: hasSpecialChar.test(password),
        minLen8: minLen8.test(password),
        validLen: password.length <= maxLen
    };
};

export function readCookie(cookieName) {
    return localStorage.getItem(cookieName)
}

export function handleBackToTopClick() {
    window.scrollTo(0, 0); // scroll to top
}

export function datesInCurrentWeek(dates=[]) {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const startOfWeek = new Date(today);
    const endOfWeek = new Date(today);

    // Set start of the week (Monday)
    startOfWeek.setDate(today.getDate() - ((dayOfWeek + 6) % 7));
    startOfWeek.setHours(0, 0, 0, 0);

    // Set end of the week (Sunday)
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    endOfWeek.setHours(23, 59, 59, 999);

    // Filter dates that fall within this range
    return dates.filter(date => {
        const d = new Date(date);
        return d >= startOfWeek && d <= endOfWeek;
    });
};

export function getWeekdayPresence(dates=[]) {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const startOfWeek = new Date(today);
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    // Set start of the week to Monday
    startOfWeek.setDate(today.getDate() - ((dayOfWeek + 6) % 7));
    startOfWeek.setHours(0, 0, 0, 0);

    // Initialize week object
    const weekPresence = {
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
        Sunday: false,
    };

    // Loop through the week and update presence for each day
    for (let i = 0; i < 7; i++) {
        const currentDay = new Date(startOfWeek);
        currentDay.setDate(startOfWeek.getDate() + i);
        const dayName = days[(i + 1) % 7]; // Shift to match Monday as the start

        // Check if the current day exists in dates
        if (dates.some(date => new Date(date).toDateString() === currentDay.toDateString())) {
            weekPresence[dayName] = true;
        }
    }

    return weekPresence;
};